import { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { fileToDataURL } from '../../utils/fileUtils';
import './PDFSigner.css';

const SignatureModal = ({ onClose, onSave }) => {
  const [mode, setMode] = useState('draw'); // draw or upload
  const sigCanvas = useRef(null);
  const [uploadedSignature, setUploadedSignature] = useState(null);

  const handleClear = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert('Please upload an image file');
      return;
    }

    const dataUrl = await fileToDataURL(file);
    setUploadedSignature(dataUrl);
  };

  const handleSave = () => {
    let signatureDataUrl;

    if (mode === 'draw') {
      if (sigCanvas.current.isEmpty()) {
        alert('Please draw a signature first');
        return;
      }
      signatureDataUrl = sigCanvas.current.toDataURL('image/png');
    } else {
      if (!uploadedSignature) {
        alert('Please upload a signature image');
        return;
      }
      signatureDataUrl = uploadedSignature;
    }

    onSave(signatureDataUrl);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal signature-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Create Signature</h2>
          <button className="btn btn-ghost close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="signature-mode-tabs">
            <button
              className={`tab ${mode === 'draw' ? 'active' : ''}`}
              onClick={() => setMode('draw')}
            >
              Draw Signature
            </button>
            <button
              className={`tab ${mode === 'upload' ? 'active' : ''}`}
              onClick={() => setMode('upload')}
            >
              Upload Image
            </button>
          </div>

          {mode === 'draw' ? (
            <div className="signature-draw-area">
              <SignatureCanvas
                ref={sigCanvas}
                canvasProps={{
                  className: 'signature-canvas',
                }}
                backgroundColor="white"
                penColor="black"
              />
              <button className="btn btn-secondary clear-btn" onClick={handleClear}>
                Clear
              </button>
            </div>
          ) : (
            <div className="signature-upload-area">
              {uploadedSignature ? (
                <div className="signature-preview">
                  <img src={uploadedSignature} alt="Signature" />
                  <button
                    className="btn btn-secondary"
                    onClick={() => setUploadedSignature(null)}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <label className="upload-label">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleUpload}
                    style={{ display: 'none' }}
                  />
                  <div className="upload-placeholder">
                    <svg
                      width="48"
                      height="48"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <p>Click to upload signature image</p>
                    <span>PNG, JPG, or GIF</span>
                  </div>
                </label>
              )}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-success" onClick={handleSave}>
            Save Signature
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignatureModal;
